import { forEach } from 'lodash';

import NavMobile from 'view/nav/navMobile';
import NavDesktop from 'view/nav/navDesktop';
import NavFlexible from 'view/nav/navFlexible';

export default class Nav {
  constructor(hasSticky) {
    this.root = document.body;
    this.hasSticky = hasSticky;
    this.initMobile();
    this.initDesktop();
    this.initFlexible();
  }

  initFlexible() {
    let flexibles = document.querySelectorAll('[class*="u-nav-local--"][class*="--flexible"]');
    forEach(flexibles, el => new NavFlexible(el));

  }

  initMobile() {
    const el = this.root.querySelector(`.u-nav-mobile, [class*='u-nav-mobile--']`);

    if (!el) {
      return;
    }

    this.mobile = new NavMobile(el);
  }

  initDesktop() {
    this.desktop = new NavDesktop(this.root, this.hasSticky);
  }
}
